import {Box} from '@mui/material';
import OnboardingMessageRequest from './OnboardingMessageRequest';
import {ITaskItem} from '../../../../../dto/Task.dto';
import React from 'react';

const defaultState = {
  defaultStep: 0,
};

const OnboardingMessageCreate = ({
  taskData,
  handleCancel,
  isGT,
  setIsGT,
}: {
  taskData: ITaskItem;
  handleCancel: () => void;
  isGT: boolean;
  setIsGT: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Box>
      <OnboardingMessageRequest
        {...defaultState}
        taskData={taskData}
        handleCancel={handleCancel}
        isGT={isGT}
        setIsGT={setIsGT}
      />
    </Box>
  );
};

export default OnboardingMessageCreate;
